export enum DashboardType {
  OVERVIEW = 'overview',
  ANALYTICS = 'analytics',
}
